import { ICita } from "./cita.modelo";

export enum eTipoIdentificador {
  nif = "N" as any,
  cif = "C" as any,
  NIE = "E" as any,
  Otros = "O" as any,
}

// Interfaz con los datos del solicitante
export interface ISolicitante {
  id_solicitante: number;
  tiponif: string;
  nif: string;
  nombre: string;
  apellido1: string;
  apellido2: string;
  email: string;
  tlf1: string;
  tlf2: string;
  ID_FK_REPRESENTANTE: number;
  asunto: string;
}

// Clase con los datos del solicitante
export class cSolicitante implements ISolicitante {
  public id_solicitante: number;
  public tiponif: string;
  public nif: string;
  public nombre: string;
  public apellido1: string;
  public apellido2: string;
  public email: string;
  public tlf1: string;
  public tlf2: string;
  public ID_FK_REPRESENTANTE: number;
  public asunto: string;

  contructor() {
    this.id_solicitante = 0;
    this.tiponif = "N";
    this.nif = "";
    this.nombre = "";
    this.apellido1 = "";
    this.apellido2 = "";
    this.email = "";
    this.tlf1 = "";
    this.tlf2 = "";
    this.ID_FK_REPRESENTANTE = 0;
    this.asunto = "";
  }
  public AsignarInterface(oDato: ISolicitante) {
    Object.assign(this, oDato);
  }
}

// Interfaz que contiene los datos del solicitante y las citas pendientes
export interface ISolicitanteCitasPendientes {
  SOLICITANTE: ISolicitante;
  CITAS_PENDIENTES: ICita[];
}
